// replace-titles.js — versión robusta
document.addEventListener('DOMContentLoaded', function () {
  try {
    var root = document.querySelector('.ws-workstation');
    if (!root) return;

    // abrir ficha técnica por defecto y marcar clase para estilos
    var details = root.querySelector('details.specs-details');
    if (details) {
      details.open = true;
      details.classList.add('fixed-open');
    }

    // BUSCAR bloques por texto del H3 (más fiable que posiciones)
    var blocks = Array.prototype.slice.call(root.querySelectorAll('.three-col > *'));
    var benefBlocks = [];
    var usesBlock = null;

    blocks.forEach(function (blk) {
      var title = blk.querySelector('h3');
      var titleText = title ? title.textContent.trim().toLowerCase() : '';
      if (titleText.indexOf('beneficios') !== -1 || titleText.indexOf('beneficio') !== -1) {
        benefBlocks.push(blk);
      } else if (titleText.indexOf('tipo') !== -1 || titleText.indexOf('uso') !== -1) {
        usesBlock = blk;
      } else {
        // fallback: if block contains 'benef' keywords inside lists, treat as benefits
        var txt = blk.textContent.toLowerCase();
        if (txt.indexOf('rendimiento') !== -1 || txt.indexOf('escalabilidad') !== -1) benefBlocks.push(blk);
      }
    });

    // Si encontramos al menos 2 bloques de beneficios, fusionarlos (solo entre ellos)
    if (benefBlocks.length > 1) {
      var primary = benefBlocks[0];
      for (var i = 1; i < benefBlocks.length; i++) {
        var second = benefBlocks[i];
        var list1 = primary.querySelector('ul') || primary.querySelector('.benef-list');
        var list2 = second.querySelector('ul') || second.querySelector('.benef-list');
        if (list1 && list2) {
          while (list2.firstElementChild) list1.appendChild(list2.firstElementChild);
        } else if (!list1 && list2) {
          // move the whole list2 into primary
          primary.appendChild(list2);
        }
        // remove the now-empty block element
        second.parentNode && second.parentNode.removeChild(second);
      }
    }

    // Asegurar que el bloque de "Tipos de uso" (usesBlock) esté en la columna derecha
    if (usesBlock) {
      usesBlock.style.gridColumn = '2';
      usesBlock.style.display = 'block';
    }

    // eliminar encabezados h3 vacíos que generan huecos
    Array.prototype.forEach.call(root.querySelectorAll('.three-col h3'), function(h){
      if (!h.textContent.trim()) h.remove();
      else h.style.display = 'inline-block';
    });

    // eliminar nodos vacíos creados por theme (p/span/div vacíos sin atributos útiles)
    Array.prototype.forEach.call(root.querySelectorAll('p,div,span'), function(node){
      if (!node.textContent.trim() && node.children.length === 0) {
        var keep = false;
        if (node.getAttribute && (node.getAttribute('role') || node.getAttribute('aria-label') || window.getComputedStyle(node).backgroundImage !== 'none')) keep = true;
        if (!keep) node.remove();
      }
    });

    // eliminar nodos de clase spacer/widget-spacer si existen
    Array.prototype.forEach.call(root.querySelectorAll('.spacer, .widget-spacer'), function(n){ n.remove(); });

    // A11Y: enlazar "Ver ficha técnica" (bottom CTA) para abrir y enfocar
    var bottomLink = root.querySelector('.bottom-cta a[href="#ficha-content"]');
    if (bottomLink && details) {
      bottomLink.addEventListener('click', function(e){
        e.preventDefault();
        details.open = true;
        details.classList.add('fixed-open');
        var target = document.getElementById('ficha-content');
        if (target) {
          target.setAttribute('tabindex','-1');
          target.focus({preventScroll:true});
          setTimeout(function(){ target.scrollIntoView({behavior:'smooth', block:'start'}); }, 50);
        }
      });
    }

  } catch (err) {
    // no impedir render si falla
    console.error('replace-titles.js error', err);
  }
});
